export const GAME_OVER_OVERLAY_DELAY_MS = 1800;

export interface GameOverSequenceDeps {
  readonly isOverlayPlaying: () => boolean;
  readonly playPlayerShipDestruction: () => void;
  readonly scheduleDelay: (delayMs: number, callback: () => void) => void;
  readonly playOverlay: () => void;
}

export function startGameOverSequence(deps: GameOverSequenceDeps): boolean {
  if (deps.isOverlayPlaying()) return false;
  deps.playPlayerShipDestruction();
  deps.scheduleDelay(GAME_OVER_OVERLAY_DELAY_MS, () => {
    if (deps.isOverlayPlaying()) return;
    deps.playOverlay();
  });
  return true;
}
